import { AccessRights } from "@dandelion/core";
import { Users } from "../enum/Users";

export const defaultAccessRights: Map<string, AccessRights> = new Map([
  [
    'sensitiveData',
    {
      read_roles: [Users.ADMIN, Users.WRITER, Users.READER],
      write_roles: [Users.ADMIN, Users.WRITER],
    },
  ],
  [
    'public',
    {
      read_roles: [Users.ADMIN, Users.WRITER, Users.READER, Users.SUPPORT_ADMIN],
      write_roles: [Users.ADMIN, Users.WRITER],
    },
  ],
]);
